import { createContext, useContext } from "react";

import type { Device } from "~/providers/device-provider";

interface DeviceContext {
  devices: Device[];
}

export const DeviceContext = createContext<DeviceContext | undefined>(
  undefined,
);

export const useDevice = () => {
  const context = useContext(DeviceContext);

  if (context === undefined) {
    throw new Error(
      "useDevice must be used within a DeviceProvider, but no provider was found",
    );
  }

  return context;
};
